'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { COLUMN_TYPE } from '@/constants/table';

const emptyFilter = {
  enabled: false,
  value: []
};

export const defaultSupervisedAgentsTable = [
  {
    text: 'headers.agentName',
    align: 'start',
    sortable: true,
    value: 'agentName',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: true,
    columnIndex: 0,
    width: '150px',
    customFilter: emptyFilter
  },
  {
    text: 'headers.agentState',
    align: 'start',
    sortable: true,
    value: 'agentState',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: true,
    columnIndex: 1,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.agentStateTime',
    align: 'start',
    sortable: true,
    value: 'agentStateTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: true,
    columnIndex: 2,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.availability',
    align: 'start',
    sortable: true,
    value: 'availability',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: true,
    columnIndex: 3,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentLoadAllowance',
    align: 'start',
    sortable: true,
    value: 'currentLoadAllowance',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: false,
    columnIndex: 4,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.activeBP',
    align: 'start',
    sortable: true,
    value: 'activeBP',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: true,
    columnIndex: 5,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.businessProcessHandled',
    align: 'start',
    sortable: true,
    value: 'businessProcessHandled',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: true,
    columnIndex: 6,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentInteractionHandlingTime',
    align: 'start',
    sortable: true,
    value: 'currentInteractionHandlingTime',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: true,
    columnIndex: 7,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.averageHandlingTime',
    align: 'start',
    sortable: true,
    value: 'averageHandlingTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: true,
    columnIndex: 8,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalIncomingInteractions',
    align: 'start',
    sortable: true,
    value: 'totalIncomingInteractions',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: true,
    columnIndex: 9,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalLoginTime',
    align: 'start',
    sortable: true,
    value: 'totalLoginTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: true,
    columnIndex: 10,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentTimeInBreak',
    align: 'start',
    sortable: true,
    value: 'currentTimeInBreak',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: true,
    columnIndex: 11,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalNotReadyTime',
    align: 'start',
    sortable: true,
    value: 'totalNotReadyTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: true,
    columnIndex: 12,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentReadyTime',
    align: 'start',
    sortable: true,
    value: 'currentReadyTime',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: true,
    columnIndex: 13,
    width: 'auto',
    customFilter: emptyFilter
  },
  // What even is Preview
  {
    text: 'headers.averagePreviewTime',
    align: 'start',
    sortable: true,
    value: 'averagePreviewTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: true,
    columnIndex: 14,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.assignedBP',
    align: 'start',
    sortable: true,
    value: 'assignedBP',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: false,
    columnIndex: 15,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.remoteParty',
    align: 'start',
    sortable: true,
    value: 'remoteParty',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 16,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.interactionState',
    align: 'start',
    sortable: true,
    value: 'interactionState',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: false,
    columnIndex: 17,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalMissed',
    align: 'start',
    sortable: true,
    value: 'totalMissed',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 18,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.businessProcessRejected',
    align: 'start',
    sortable: true,
    value: 'businessProcessRejected',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 19,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.lastLoginTime',
    align: 'start',
    sortable: true,
    value: 'lastLoginTime',
    type: COLUMN_TYPE.DATE,
    filterable: true,
    show: false,
    columnIndex: 20,
    width: 'auto',
    customFilter: emptyFilter
  },
  // How does this one even work, it's always zero!
  {
    text: 'headers.totalCallbacksRequested',
    align: 'start',
    sortable: true,
    value: 'totalCallbacksRequested',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 21,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalNoAnswer',
    align: 'start',
    sortable: true,
    value: 'totalNoAnswer',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 22,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalHandlingOutgoing',
    align: 'start',
    sortable: true,
    value: 'totalHandlingOutgoing',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 23,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalBreakTime',
    align: 'start',
    sortable: true,
    value: 'totalBreakTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 24,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentBreakName',
    align: 'start',
    sortable: true,
    value: 'currentBreakName',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: false,
    columnIndex: 25,
    width: 'auto',
    customFilter: emptyFilter
  },
  // Currently useless has same value as currentTimeInBreak, and we don't have a how much time should the break last either unless I pull it from the global getters for breaks (haven't checked) and get it by break name
  {
    text: 'headers.timeToExpirationOfBreak',
    align: 'start',
    sortable: true,
    value: 'timeToExpirationOfBreak',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: false,
    columnIndex: 26,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentBusyTime',
    align: 'start',
    sortable: true,
    value: 'currentBusyTime',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: false,
    columnIndex: 27,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentHandlingOutgoingTime',
    align: 'start',
    sortable: true,
    value: 'currentHandlingOutgoingTime',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: false,
    columnIndex: 28,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.currentBackOfficeTime',
    align: 'start',
    sortable: true,
    value: 'currentBackOfficeTime',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: false,
    columnIndex: 29,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalHandlingTime',
    align: 'start',
    sortable: true,
    value: 'totalHandlingTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 30,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalBackOfficeTime',
    align: 'start',
    sortable: true,
    value: 'totalBackOfficeTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 31,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalReadyTime',
    align: 'start',
    sortable: true,
    value: 'totalReadyTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 32,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalWrapUpTime',
    align: 'start',
    sortable: true,
    value: 'totalWrapUpTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 33,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalTransfer',
    align: 'start',
    sortable: true,
    value: 'totalTransfer',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 34,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalConsultOrConferenceInitiated',
    align: 'start',
    sortable: true,
    value: 'totalConsultOrConferenceInitiated',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 35,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalAnsweredAsConsult',
    align: 'start',
    sortable: true,
    value: 'totalAnsweredAsConsult',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 36,
    width: 'auto',
    customFilter: emptyFilter
  },
  // Not sure how but It had a value at some point, not sure how to test it
  {
    text: 'headers.totalOutgoingExternal',
    align: 'start',
    sortable: true,
    value: 'totalOutgoingExternal',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 37,
    width: 'auto',
    customFilter: emptyFilter
  },
  // How to test this one?
  {
    text: 'headers.totalOutgoingInternal',
    align: 'start',
    sortable: true,
    value: 'totalOutgoingInternal',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 38,
    width: 'auto',
    customFilter: emptyFilter
  },
  // How to test this one?
  {
    text: 'headers.totalOutgoingPrivate',
    align: 'start',
    sortable: true,
    value: 'totalOutgoingPrivate',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 39,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.averageRingTime',
    align: 'start',
    sortable: true,
    value: 'averageRingTime',
    type: COLUMN_TYPE.NUMBER,
    filterable: true,
    show: false,
    columnIndex: 40,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalDialingTime',
    align: 'start',
    sortable: true,
    value: 'totalDialingTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 41,
    width: 'auto',
    customFilter: emptyFilter
  },
  // Not sure how but It had a value at some point, not sure how to test it
  {
    text: 'headers.totalUnsuccessfulDialingTime',
    align: 'start',
    sortable: true,
    value: 'totalUnsuccessfulDialingTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 42,
    width: 'auto',
    customFilter: emptyFilter
  },
  // Not sure how but It had a value at some point, not sure how to test it
  {
    text: 'headers.totalUnsuccessfulDialingAttempts',
    align: 'start',
    sortable: true,
    value: 'totalUnsuccessfulDialingAttempts',
    type: COLUMN_TYPE.INTEGER,
    filterable: true,
    show: false,
    columnIndex: 43,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.busyToLoginTimeRatio',
    align: 'start',
    sortable: true,
    value: 'busyToLoginTimeRatio',
    type: COLUMN_TYPE.PERCENTAGE,
    filterable: true,
    show: false,
    columnIndex: 44,
    width: 'auto',
    customFilter: emptyFilter
  },
  // What even is Preview
  {
    text: 'headers.totalPreviewTime',
    align: 'start',
    sortable: true,
    value: 'totalPreviewTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 45,
    width: 'auto',
    customFilter: emptyFilter
  },
  // What even is Preview
  {
    text: 'headers.currentPreviewTime',
    align: 'start',
    sortable: true,
    value: 'currentPreviewTime',
    type: COLUMN_TYPE.TIME_FROM_NOW,
    filterable: false,
    show: false,
    columnIndex: 46,
    width: 'auto',
    customFilter: emptyFilter
  }
];

export const defaultSupervisedInteractionsTable = [
  {
    text: 'headers.interactionId',
    align: 'start',
    sortable: true,
    value: 'interactionId',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: true,
    columnIndex: 0,
    width: '150px',
    customFilter: emptyFilter
  },
  {
    text: 'headers.agentName',
    align: 'start',
    sortable: true,
    value: 'agentName',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: true,
    columnIndex: 1,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.agentState',
    align: 'start',
    sortable: true,
    value: 'agentState',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: false,
    columnIndex: 2,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.agentStateTime',
    align: 'start',
    sortable: true,
    value: 'agentStateTime',
    type: COLUMN_TYPE.TIME,
    filterable: false,
    show: false,
    columnIndex: 3,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.activeBp',
    align: 'start',
    sortable: true,
    value: 'businessProcessName',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: false,
    columnIndex: 4,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.remoteParty',
    align: 'start',
    sortable: true,
    value: 'remoteParty',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: true,
    columnIndex: 5,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.interactionMediaType',
    align: 'start',
    sortable: true,
    value: 'interactionMediaType',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: true,
    columnIndex: 6,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.entryTime',
    align: 'start',
    sortable: false,
    value: 'entryTime',
    type: COLUMN_TYPE.DATE,
    filterable: true,
    show: false,
    columnIndex: 7,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.interactionStateName',
    align: 'start',
    sortable: true,
    value: 'interactionStateName',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: true,
    columnIndex: 8,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.interactionStateTime',
    align: 'start',
    sortable: false,
    value: 'interactionStateTime',
    type: COLUMN_TYPE.DATE,
    filterable: true,
    show: false,
    columnIndex: 9,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.demands',
    align: 'start',
    sortable: true,
    value: 'demands',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: true,
    columnIndex: 10,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.demandsFilter',
    align: 'start',
    sortable: true,
    value: 'demandsFilter',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 11,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.totalWaitingTime',
    align: 'start',
    sortable: false,
    value: 'totalWaitingTime',
    type: COLUMN_TYPE.TIME,
    filterable: true,
    show: false,
    columnIndex: 12,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.systemDID',
    align: 'start',
    sortable: true,
    value: 'systemDID',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 13,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.interactionType',
    align: 'start',
    sortable: true,
    value: 'interactionType',
    type: COLUMN_TYPE.INCLUDES,
    filterable: true,
    show: false,
    columnIndex: 14,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.assignedTo',
    align: 'start',
    sortable: true,
    value: 'assignedTo',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 15,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.customerId',
    align: 'start',
    sortable: true,
    value: 'customerId',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 16,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.interactionStateId',
    align: 'start',
    sortable: true,
    value: 'interactionStateId',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 17,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.businessProcessId',
    align: 'start',
    sortable: true,
    value: 'businessProcessId',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 18,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.agentId',
    align: 'start',
    sortable: true,
    value: 'agentId',
    type: COLUMN_TYPE.UNKNOWN,
    filterable: true,
    show: false,
    columnIndex: 19,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.lastStateStartTime',
    align: 'start',
    sortable: false,
    value: 'lastStateStartTime',
    type: COLUMN_TYPE.DATE,
    filterable: true,
    show: false,
    columnIndex: 20,
    width: 'auto',
    customFilter: emptyFilter
  },
  {
    text: 'headers.bpWaitingTime',
    align: 'start',
    sortable: false,
    value: 'bpWaitingTime',
    type: COLUMN_TYPE.TIME,
    filterable: true,
    show: false,
    columnIndex: 21,
    width: 'auto',
    customFilter: emptyFilter
  }
];

const state = {
  selectedSupervisorWallboard: {},
  supervisedAgents: [],
  supervisedInteractions: [],
  name: 'SUPERVISOR'
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
